import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { audioCommentsPagePath } from '../utils/appRoutes';
import CassetteLoader from '../components/CassetteLoader';

const AudioCommentsLegacyRedirect: React.FC = () => {
  const { trackId, '*': splat } = useParams<{ trackId: string; '*': string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!trackId || !splat?.endsWith('/comments')) {
      navigate('/dashboard', { replace: true });
      return;
    }

    const fileId = splat.slice(0, -'/comments'.length);
    const selectedComment = searchParams.get('selectedComment') || undefined;
    navigate(audioCommentsPagePath(trackId, fileId, { selectedComment }), { replace: true });
  }, [trackId, splat, searchParams, navigate]);

  return <CassetteLoader />;
};

export default AudioCommentsLegacyRedirect;
